import { SESSION_STORAGE_KEY } from './portalConfig'

export function getStoredSessionId() {
  return localStorage.getItem(SESSION_STORAGE_KEY) || ''
}

export function setStoredSessionId(sessionId) {
  if (sessionId)
    localStorage.setItem(SESSION_STORAGE_KEY, sessionId)
  else
    localStorage.removeItem(SESSION_STORAGE_KEY)
}

export function getTrackingHeaders(extra = {}) {
  const sessionId = getStoredSessionId()
  const headers = { ...extra }
  if (sessionId)
    headers['x-session-id'] = sessionId
  return headers
}
